export const isValidLinkedInCompanyUrl = (url: string): boolean => {
  return /^(((https?:\/\/)?(www\.)?)?([a-z]{2}\.)?)?(linkedin\.com\/(company|school|showcase|groups|sales)\/[^/]+)\/?/i.test(
    url
  );
};

export const isValidLinkedInContactUrl = (url: string): boolean => {
  return /^(((https?:\/\/)?(www\.)?)?([a-z]{2}\.)?)?(linkedin\.com\/in\/[^/]+)\/?/i.test(
    url
  );
};

export const cleanLinkedInUrl = (url: string): string => {
  return url.split(/[?#]/)[0];
};
